import { __assign } from "tslib";
import { UserType, ItemType } from '../domain';
import { createSimpleCustomFieldsApi } from '../custom-fields';
export * from './dto';
var MAX_PAGE_SIZE = 200;
export var createTeamApi = function (baseUrl, http) {
    var agentsPath = baseUrl + "/agents";
    var groupsPath = baseUrl + "/groups";
    var teamPath = baseUrl + "/teams";
    var locationPath = baseUrl + "/locations";
    var agentPermissionPath = function (agentId) { return agentsPath + "/" + agentId + "/permissions"; };
    return {
        getActiveAgents: function (dto) {
            var text = dto.text || '';
            var pageSize = dto.pageSize || MAX_PAGE_SIZE;
            var sortType = dto.sortType ? { agentSortType: dto.sortType } : {};
            return http.post(agentsPath + "/search", __assign(__assign(__assign({}, dto), sortType), { pageSize: pageSize, text: text, userTypes: [UserType.AUTHENTICATED] }));
        },
        getPendingAgents: function (dto) {
            var text = dto.text || '';
            var pageSize = dto.pageSize || MAX_PAGE_SIZE;
            var sortType = dto.sortType ? { agentSortType: dto.sortType } : {};
            return http.post(agentsPath + "/search", __assign(__assign(__assign({}, dto), sortType), { pageSize: pageSize, text: text, userTypes: [UserType.PENDING] }));
        },
        getAllGroups: function () {
            return http.get(groupsPath);
        },
        getGroupMembers: function (dto) {
            var pageSize = dto.pageSize || MAX_PAGE_SIZE;
            var sortType = dto.sortType ? { agentSortType: dto.sortType } : {};
            return http.post(agentsPath + "/search", __assign(__assign({}, sortType), { pageSize: pageSize, groupIds: [dto.groupId] }));
        },
        setAgentPermission: function (dto) {
            return http.put("" + agentPermissionPath(dto.agentId), { permissionLevel: dto.permissionLevel, roleId: dto.roleId });
        },
        removeAgent: function (dto) {
            return http.delete("" + agentPermissionPath(dto.agentId));
        },
        removeAgentFromGroup: function (dto) {
            return http.delete(groupsPath + "/" + dto.groupId + "/members/" + dto.agentId);
        },
        addAgentToGroup: function (dto) {
            return http.post(groupsPath + "/" + dto.groupId + "/members", { userId: dto.agentId });
        },
        editGroupsMembers: function (dto) {
            return http.post(groupsPath + "/members", dto);
        },
        addGroup: function (dto) {
            return http.post("" + groupsPath, { name: dto.name, settings: { avatarPath: '' } });
        },
        editGroup: function (dto) {
            return http.put(groupsPath + "/" + dto.groupId, { name: dto.name, settings: { avatarPath: '' } });
        },
        deleteGroup: function (dto) {
            return http.delete(groupsPath + "/" + dto.groupId);
        },
        inviteMember: function (dto) {
            return http.post(agentsPath + "/invite", dto);
        },
        revokeInvitation: function (dto) {
            return http.post(agentsPath + "/" + dto.agentId + "/revoke-invitation", {});
        },
        setAgentLocation: function (dto) {
            return http.post(agentsPath + "/" + dto.id + "/data", { location: dto.location });
        },
        setAgentChannel: function (dto) {
            return http.post(agentsPath + "/channel", dto);
        },
        setAgentsChannels: function (dto) {
            return http.post(agentsPath + "/features", dto);
        },
        setAgentsChannel: function (dto) {
            return http.post(agentsPath + "/channels", dto);
        },
        setAgentsMaxWorkloads: function (dto) {
            return http.post(agentsPath + "/features/workloads", dto);
        },
        setAgentStatus: function (dto) {
            return http.post(agentsPath + "/status", dto);
        },
        setAgentStatusNew: function (dto) {
            return http.post(agentsPath + "/status/new", dto);
        },
        setAgentStatusOnBehalf: function (dto) {
            return http.post(agentsPath + "/status/new/onBehalf", dto);
        },
        getCurrentAgent: function () {
            return http.get(agentsPath + "/me");
        },
        getAgent: function (agentId) { return http.get(agentsPath + "/" + agentId); },
        getTeams: function () { return http.get("" + teamPath); },
        getTeam: function (dto) { return http.get(teamPath + "/" + dto.id); },
        updateTeams: function (dto) { return http.put("" + teamPath, dto); },
        getLocations: function () { return http.get("" + locationPath); },
        getLocation: function (dto) { return http.get(locationPath + "/" + dto.id); },
        updateLocations: function (dto) { return http.put("" + locationPath, dto); },
        setAgentDataField: function (dto) { return http.put(agentsPath + "/" + dto.userId + "/" + dto.agentDataField, dto); },
        removeAgentDataField: function (dto) {
            return http.delete(agentsPath + "/" + dto.userId + "/" + dto.agentDataField);
        },
        updateAgentCustomFields: function (dto) {
            return http.put(agentsPath + "/" + dto.id + "/fields", dto);
        },
        customFields: createSimpleCustomFieldsApi(agentsPath, http, ItemType.AGENT),
        endAgentSessions: function (id) {
            return http.post(agentsPath + "/" + id + "/handling/end", {});
        },
        setAgentInterfaceLocale: function (dto) {
            return http.put(agentsPath + "/me/interfaceLocale", dto);
        }
    };
};
//# sourceMappingURL=index.js.map